import { Component, OnInit, Input, ViewChild } from '@angular/core';
import {LangChange} from "../../../../../../lang-change";
import {Utils} from "../../../../../../common/services/Utils";
import {EnrollCabinet} from "../../../model/enroll-cabinet";
import {TranslateService} from '@ngx-translate/core';
import {MatDialog} from '@angular/material';
import {Language} from "../../../../../../common/models/language";

@Component({
  selector: 'app-enroll-personal-achievements',
  templateUrl: './enroll-personal-achievements.component.html',
  styleUrls: ['./enroll-personal-achievements.component.scss']
})
export class EnrollPersonalAchievementsComponent extends LangChange implements OnInit {

  constructor(public _translateService: TranslateService,
              private dialog: MatDialog,
              private utils: Utils) {
    super(_translateService);
  }

  @Input() public data: EnrollCabinet;
  @Input() public dics: any;
  @Input() public applicationFormDisabled: boolean;
  @ViewChild('fileInput') fileInputVariable;

  onLangChange(language: Language): void {
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/enroll/components/enroll-cabinet/tabs/enroll-personal-achievements/enroll-personal-achievements.component.ts